module.exports = __webpack_public_path__ + "img/globe-empty.d7affb0.svg";